import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams, useNavigate, useParams } from "react-router-dom";
import api from "../../utils/api";
import Swal from "sweetalert2";

const PaymentSuccess = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { lang } = useParams();
  const currentLang = lang || 'en';
  const sessionId = searchParams.get("session_id");

  useEffect(() => {
    if (!sessionId) {
      navigate(`/${currentLang}`);
      return;
    }

    const checkPayment = async () => {
      try {
        const res = await api.get(`/payments/verify/${sessionId}`);
        if (res.data.data.is_paid) {
          await Swal.fire(
            t("payment_success.success_title"),
            t("payment_success.success_message"),
            "success"
          );
          navigate("/profile");
        }
      } catch {
        Swal.fire(t("payment_success.error_title"), t("payment_success.error_message"), "error");
        navigate(`/${currentLang}/forms`);
      }
    };

    checkPayment();
  }, [sessionId, navigate, currentLang, t]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      {t("payment_success.verifying")}
    </div>
  );
};

export default PaymentSuccess;
